import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, Table, Form, Input, InputNumber, Modal, message } from "antd";
import RenderTxt from "@components/renderTxt";
import SystemApi from "@api/sys";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import SearchForm from "@components/SearchForm";
import moment from "moment";
import { dictApi } from "@api/newApi";

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};
const KnowledgeBase = ({ userInfo }) => {
  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [editId, setEditId] = useState();
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useState({
    classifyKeys: ["deviceBusinessType"],
  });
  const [tableSource, setTableSource] = useState({});

  const columns = [
    {
      title: "名称",
      dataIndex: "disName",
      align: "center",
      key: "disName",
    },
    {
      title: "值",
      dataIndex: "value",
      align: "center",
      key: "value",
    },
    {
      title: "排序",
      dataIndex: "orderIdx",
      align: "center",
      key: "orderIdx",
    },
    {
      title: "创建时间",
      dataIndex: "updateAt",
      align: "center",
      key: "updateAt",
      render: (text) => moment(text).format("YY-MM-DD HH:MM:SS"),
    },
    {
      title: "操作",
      dataIndex: "action",
      align: "center",
      key: "action",
      render: (text, obj) => {
        return (
          <>
            <Button type="primary" onClick={() => editRecord(obj)}>
              编辑
            </Button>
            <Button
              style={{ marginLeft: 8 }}
              type="primary"
              onClick={() => delRecord(obj.id)}
              danger
            >
              删除
            </Button>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    getListPages();
  }, [searchParams]);

  const getListPages = () => {
    setLoading(true);
    SystemApi.selectWithClassifyKeys(searchParams).then((res) => {
      setLoading(false);
      if (res.status !== "0") return;
      const { deviceBusinessType = [] } = res.data;

      setTableSource({
        data: deviceBusinessType.map((m) => ({ ...m, key: m.id })),
      });
    });
  };

  const delRecord = (id) => {
    Modal.confirm({
      onOk: () => {
        dictApi.dictDel({ id }).then((res) => {
          if (res.status !== "0") return;
          message.success("删除成功");
          getListPages();
        });
      },
      title: "请确认",
      icon: <ExclamationCircleOutlined />,
      content: "是否删除",
      okText: "确认",
      cancelText: "取消",
    });
  };

  const editRecord = (obj) => {
    setVisible(true);
    setEditId(obj.id);
    form.setFieldsValue({ ...obj });
  };

  const cancel = () => {
    setVisible(false);
    form.resetFields();
    setEditId(null);
  };

  const save = () => {
    form.validateFields().then((values) => {
      const params = { ...values };
      if (editId) {
        setConfirmLoading(true);
        dictApi
          .dictUpdate({
            classifyId: "57",
            classifyKey: "deviceBusinessType",
            classifyName: "设备业务类型",
            ...params,
            id: editId,
          })
          .then((res) => {
            setConfirmLoading(false);
            if (res.status !== "0") return;
            message.success("修改成功");
            cancel();
            getListPages();
          });
      } else {
        setConfirmLoading(true);
        dictApi
          .dictCreate({
            classifyId: "57",
            classifyKey: "deviceBusinessType",
            classifyName: "设备业务类型",
            ...params,
          })
          .then((res) => {
            setConfirmLoading(false);
            if (res.status !== "0") return;
            message.success("新增成功");
            cancel();
            getListPages();
          });
      }
    });
  };

  const handleTableChange = (pagination) => {
    const params = {
      ...searchParams,
    };
    setSearchParams(params);
  };

  return (
    <div style={{ padding: 20 }}>
      <Button
        type="primary"
        style={{ marginBottom: "10px" }}
        onClick={() => setVisible(true)}
      >
        新增
      </Button>
      <Table
        loading={loading}
        columns={columns}
        dataSource={tableSource.data}
        pagination={false}
        onChange={handleTableChange}
      />
      {visible && (
        <Modal
          title={editId ? "编辑" : "新增"}
          open={visible}
          onCancel={cancel}
          onOk={save}
          confirmLoading={confirmLoading}
        >
          <Form {...layout} form={form}>
            <Form.Item
              label="名称"
              name="disName"
              rules={[{ required: true, message: "请输入名称!" }]}
            >
              <Input placeholder="请输入名称" />
            </Form.Item>
            <Form.Item
              label="值"
              name="value"
              rules={[{ required: true, message: "请输入值!" }]}
            >
              <Input placeholder="请输入值" />
            </Form.Item>
            <Form.Item
              label="排序"
              name="orderIdx"
              rules={[{ required: true, message: "请输入排序!" }]}
            >
              <InputNumber style={{ width: "100%" }} placeholder="请输入排序" />
            </Form.Item>
          </Form>
        </Modal>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(KnowledgeBase);
